'use client';

import React, { useState } from 'react';
import { SelectCityModal } from '@/widgets/SelectCityModal/ui';
import { Link } from '@/navigation';
import { classNames } from '@/shared/lib/classnames/classnames';
import { HeaderMenu } from './HeaderMenu';
import { HeaderMenuButton } from './HeaderMenuButton';
import { HeaderSearch } from './HeaderSearch';
import baseIcons from '@/shared/assets/sprites/base.sprite.svg';
import type { HeaderProps } from '../../model/types';
export const Header: React.FC<HeaderProps> = ({
  cityAlias,
  cityName
}) => {
  const [isSelectCityModalOpen, setIsSelectCityModalOpen] = useState<boolean>(false);
  const [isMobileSearchModalOpen, setIsMobileSearchModalOpen] = useState<boolean>(false);
  // const [isChatVisible, setIsChatVisible] = useState<boolean>(false);

  const openCityModal = () => {
    setIsSelectCityModalOpen(true);
  };
  const closeCityModal = () => {
    setIsSelectCityModalOpen(false);
  };
  const openMobileSearchModal = () => {
    setIsMobileSearchModalOpen(true);
  };
  const closeMobileSearchModal = () => {
    setIsMobileSearchModalOpen(false);
  };

  // useEffect(() => {
  //   const chatForm = document.getElementById('chat-form');

  //   const handleScroll = () => {
  //     if (!chatForm) {
  //       setIsChatVisible(false);
  //       return;
  //     }

  //     const rect = chatForm.getBoundingClientRect();
  //     setIsChatVisible(rect.top <= 64);
  //   };
  //   window.addEventListener('scroll', handleScroll, { passive: true });
  //   handleScroll();

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  return <header className={classNames('sticky top-0 z-50 w-full bg-white p-4', {})} data-sentry-component="Header" data-sentry-source-file="index.tsx">
      <div className="flex w-full items-center justify-between lg:container lg:mx-auto lg:justify-center lg:px-8">
        <div className="lg:order-2">
          <button onClick={openCityModal} translate="no" className="flex items-center text-sm font-semibold text-black transition-colors duration-200 hover:text-blue-600 focus:text-blue-600 focus:outline-none" aria-label="Выбрать город">
            <svg className="size-6" aria-hidden="true" data-sentry-element="svg" data-sentry-source-file="index.tsx">
              <use xlinkHref={`${baseIcons}#location`} data-sentry-element="use" data-sentry-source-file="index.tsx" />
            </svg>
            {cityName}
          </button>
        </div>

        <div className="lg:order-1">
          <Link href={`/${cityAlias === 'almaty' ? '' : cityAlias}`} prefetch={false} translate="no" className="text-lg font-bold transition-colors duration-200 hover:text-blue-600 lg:mr-4" data-sentry-element="Link" data-sentry-source-file="index.tsx">
            iDoctor
          </Link>
        </div>

        <div className="hidden lg:order-3 lg:block lg:w-full lg:max-w-md">
          <HeaderSearch cityAlias={cityAlias} isMobileModalOpen={isMobileSearchModalOpen} onMobileModalClose={closeMobileSearchModal} data-sentry-element="HeaderSearch" data-sentry-source-file="index.tsx" />
        </div>

        <div className="flex items-center gap-2 lg:order-3">
          {/* mobile search button */}
          <button onClick={openMobileSearchModal} className="lg:hidden">
            <svg className="size-6" data-sentry-element="svg" data-sentry-source-file="index.tsx">
              <use xlinkHref={`${baseIcons}#search`} data-sentry-element="use" data-sentry-source-file="index.tsx" />
            </svg>
          </button>

          {/* desktop */}
          <HeaderMenu cityAlias={cityAlias} data-sentry-element="HeaderMenu" data-sentry-source-file="index.tsx" />

          {/* mobile */}
          <HeaderMenuButton cityAlias={cityAlias} data-sentry-element="HeaderMenuButton" data-sentry-source-file="index.tsx" />
        </div>
      </div>

      <SelectCityModal isOpen={isSelectCityModalOpen} onClose={closeCityModal} currentCityAlias={cityAlias} data-sentry-element="SelectCityModal" data-sentry-source-file="index.tsx" />
    </header>;
};